import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  ContentTopTasksButtonComponent,
  ContentTopTasksSectionComponent,
} from '@content/ui/content-top-tasks';
import {
  computedContentSectionTheme,
  computedContentSectionId,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-content-four-top-tasks-container',
  standalone: true,
  templateUrl: './content-four-top-tasks-container.component.html',
  imports: [
    ContentTopTasksSectionComponent,
    ContentTopTasksButtonComponent,
    ContentSectionComponent,
  ],
})
export class ContentFourTopTasksContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);
}
